import React from "react";

import * as S from "./styles";

export const Slide8: React.FC = () => {
  const animeZoom = {
    scaling: {
      scale: [1, 1.3, 1],
      transition: { ease: "easeInOut", duration: 40, repeat: Infinity },
    },
  };
  return (
    <S.Container>
      <S.Text>Camisa, R$ 505, e calça, R$ 404, ambas BEN.</S.Text>
      <S.PhotoWrapper>
        <S.Photo />
      </S.PhotoWrapper>
    </S.Container>
  );
};
